// TODO: "rectangle-btn" switched to "rectangleBtn" in TF code and here - from which I presume TF still pulls it's config data? Must test.

export const assetConfigSpriteSheetLiteral = {
  btn_grey: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/buttons/grey_btn.png',
    frameData: {
      frameWidth: 135,
      frameHeight: 60
    }
  },
  btn_x: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/buttons/btn_x_small.png',
    frameData: {
      frameWidth: 32,
      frameHeight: 32
    }
  },
  rectangleBtn: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/ui/buttons/rectangle-btn.png',
    frameData: {
      frameWidth: 50,
      frameHeight: 100
    }
  },
  tileOuterTerrain: {
    path: 'https://staticcontent.knowledgehook.com/content/khg/terraforming/terrain/outer_terrain.png',
    frameData: {
      frameWidth: 150,
      frameHeight: 150
    }
  }
} as const;
